import React from 'react'
import {useCSVReader} from 'react-papaparse';
import _ from 'lodash';
import {MARKETS_LIST, PRODUCT_DETAIL_KEY, PRODUCT_FIELDS_LIST} from "../../constants/pod.constant";
import {prepareUploadedProductList} from "../../utils/uploaded-product-data-util";

const productFieldsMap = _.keyBy(PRODUCT_FIELDS_LIST, 'label');
const marketsMap = _.keyBy(MARKETS_LIST, 'label');
const marketsList = MARKETS_LIST;

const UploadProducts = ({
                            productStatistics,
                            saveProductsInProgress,
                            saveProducts,
                            podDetail,
                            setPodDetail,
                            setUploadedProducts,
                            setUploadedProductFields,
                        }) => {
    const {CSVReader} = useCSVReader();

    const processUploadedFileData = (results) => {
        setUploadedProducts(prepareUploadedProductList(results.data));
        prepareUploadedProductFields(results.data[0]);
    }

    const handleMarketChange = (event) => {
        const {name, value} = event.target;
        const existingPodDetail = {...podDetail};
        existingPodDetail.market = value;
        setPodDetail(existingPodDetail);
    }

    const prepareUploadedProductFields = (headerRow) => {
        const fields = [];
        let productField;

        const existingPodDetail = {...podDetail};
        const existingFieldMap = _.keyBy(existingPodDetail.productFieldMapping, 'label');

        _.forEach(headerRow, header => {
            productField = productFieldsMap[header] || existingFieldMap[header];

            fields.push({
                label: header,
                attribute: (productField && productField?.attribute) ? productField.attribute : '',
            });
        });

        setUploadedProductFields(fields);
    }

    return (
        <>
            <div>
                <CSVReader
                    onUploadAccepted={(results: any) => {
                        processUploadedFileData(results);
                    }}>
                    {({
                          getRootProps,
                          acceptedFile,
                          ProgressBar,
                          getRemoveFileProps,
                      }: any) => (
                        <>
                            <div className="flex justify-between">

                                <div className="flex justify-start">
                                    <div className="mr-4">
                                        <select
                                            className="input-field-max py-3 border border-gray-400 w-48 px-4 mr-2"
                                            id="market"
                                            name="market"
                                            value={podDetail?.market}
                                            onChange={handleMarketChange}>
                                            <option value="">Choose Market</option>
                                            {marketsList?.map((market, index) => (
                                                <option key={index}
                                                        value={market?.attribute}>{market.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <button {...getRootProps()}
                                            className="sharp-right-button-medium">
                                        Browse file
                                    </button>
                                    <div className="button-medium-no-border-x">
                                        {acceptedFile && acceptedFile.name}
                                    </div>
                                    <button {...getRemoveFileProps()}
                                            className="sharp-left-button-medium bg-red-500">
                                        Remove
                                    </button>
                                </div>

                                <div className="ml-6 flex justify-start">
                                    {!saveProductsInProgress &&
                                        <button className="button-medium bg-green-500"
                                                onClick={saveProducts}>
                                            Save Products
                                        </button>
                                    }

                                    {saveProductsInProgress &&
                                        <button className="button-medium bg-gray-500"
                                                disabled={saveProductsInProgress}
                                                onClick={() => {
                                                }}>
                                            Saving Products ...
                                        </button>
                                    }

                                    {productStatistics && productStatistics?.products &&
                                        <div className="ml-4 mt-1">
                                            <div><label className="field-label">Add
                                                Products: <span
                                                    className="text-blue-500">{productStatistics?.products?.add}</span></label>
                                            </div>
                                            <div><label className="field-label">Update
                                                Products: <span
                                                    className="text-blue-500">{productStatistics?.products?.update}</span></label>
                                            </div>
                                        </div>
                                    }

                                    {productStatistics && productStatistics?.parentProducts &&
                                        <div className="ml-4 mt-1">
                                            <div><label className="field-label">Add
                                                Parent Products: <span
                                                    className="text-blue-500">{productStatistics?.parentProducts?.add}</span></label>
                                            </div>
                                            <div><label className="field-label">Update
                                                Parent Products: <span
                                                    className="text-blue-500">{productStatistics?.parentProducts?.update}</span></label>
                                            </div>
                                        </div>
                                    }
                                </div>

                            </div>

                            <div className="mb-4 mt-2">
                                <ProgressBar/>
                            </div>
                        </>
                    )}
                </CSVReader>
            </div>
        </>
    )
}

export default UploadProducts
